import { format } from 'date-fns'
import HomeFeed from '@/components/dashboard/HomeFeed'
import { useAuth } from '@/hooks/useAuth'

const Dashboard = () => {
  const { athlete } = useAuth()
  const todayLabel = format(new Date(), 'EEEE, MMMM d')
  const firstName = athlete?.name?.split(' ')[0] ?? ''

  return (
    <div className="pb-8 max-w-lg mx-auto">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white">{firstName ? `Hey ${firstName}` : 'Hey'}</h1>
        <p className="text-gray-500 text-sm">{todayLabel}</p>
      </div>
      <HomeFeed />
    </div>
  )
}

export default Dashboard
